import { Avatar, type AvatarProps } from './Avatar';
import { useMemberAvatar } from '../../lib/useMemberAvatar';

/**
 * Another member's avatar: their uploaded photo through the authenticated member proxy, or their
 * initials. Use this rather than `Avatar` for anyone but the viewer — `Avatar` on its own fetches
 * the VIEWER's photo. (A Microsoft 365 profile photo is only available for the signed-in user, so
 * a teammate who never uploaded one shows as initials.)
 */
export function MemberAvatar({
  person,
  size,
  decorative,
  className,
}: {
  person: { name: string; avatarUrl: string | null };
  size?: AvatarProps['size'];
  decorative?: boolean;
  className?: string;
}) {
  const src = useMemberAvatar(person.avatarUrl);
  return (
    <Avatar
      name={person.name}
      size={size}
      fetchCustom={false}
      photoUrl={src}
      decorative={decorative}
      className={className}
    />
  );
}
